export default "__VITE_ASSET__BceQmweX__"